import React from "react";
import FocusTrap from "focus-trap-react";
import { bool, node } from "prop-types";

import Portal from "src/shared/components/Portal";

import * as S from "./styled";

class Modal extends React.Component {
  static ModalBody = S.ModalBody;
  static ModalLeft = S.ModalLeft;
  static ModalRight = S.ModalRight;
  static ModalTitle = S.ModalTitle;

  static propTypes = {
    children: node.isRequired,
    isOpen: bool
  };

  static defaultProps = {
    isOpen: false
  };

  render() {
    return (
      this.props.isOpen && (
        <Portal>
          <FocusTrap>
            <S.Modal {...this.props} />
          </FocusTrap>
        </Portal>
      )
    );
  }
}

export default Modal;
